var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"tag":"a","id":_vm.id,"type":"is-light","href":_vm.link,"target":"_blank","icon-left":"fas fa-download"}},[_vm._v("\n  "+_vm._s(this.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }